import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { DB_POSTFIX, THIRUVALLUVAR_IMAGE } from "../../utils";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import ThirukuralPopup from "./thirukuralPopup";

const Thirukural = (props) => {
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const field = (fieldName) => props?.dataSource?.[fieldName];

  useEffect(() => {
    loadThirukural();
  }, []);

  const loadThirukural = () => {
    setLoader(true);
    axios.get(ServiceUrl.TODAY_THIRUKURAL).then((res) => {
      if (res.data.status == "1") {
        setDataList(res.data.data);
      }
      setLoader(false);
    });
  };

  return (
    <section
      style={{
        backgroundColor: field("bgColor") || "rgb(67 41 113 / 20%)",
        color: field("textColor") || "#000",
      }}
      className="px-3 py-5"
    >
      <div
        className="container"
        style={{
          color: field("textColor") || "#000",
        }}
      >
        <h4 className="text-center fw-bold mb-4">
          {field("title") || "Thought of The Day"}
        </h4>
        {loader && (
          <center className="py-5">
            <Spinner />
          </center>
        )}
        {dataList.id && (
          <>
            <Row>
              <Col md={5} className="pt-3">
                <div className="mb-2">
                  <b>குறள் {dataList.kural_no}:</b>
                </div>
                <pre>{dataList.kural_tamil}</pre>
              </Col>
              <Col md={2}>
                <img src={THIRUVALLUVAR_IMAGE.default} className="w-100" />
              </Col>
              <Col md={5} className="pt-3">
                <div className="mb-2">
                  <b>விளக்கம்:</b>
                </div>
                <div>{dataList.mu_varathar_urai}</div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={12}>
                <div className="text-center">
                  <Button
                    type="button"
                    variant="primary"
                    size=""
                    onClick={(e) => setShowModal(true)}
                  >
                    Read More..
                  </Button>
                </div>
              </Col>
            </Row>
          </>
        )}
      </div>
      {showModal && (
        <ThirukuralPopup
          data={dataList}
          show={showModal}
          onHide={(e) => setShowModal(false)}
        />
      )}
    </section>
  );
};

export default Thirukural;
